import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class AuthenticationService {
  baseUrl = environment.baseUrl;
  private logueadoSource = new BehaviorSubject<boolean>(false);
  logueado$ = this.logueadoSource.asObservable();
  private currentUserSubject = new BehaviorSubject<any>({});
  public currentUser$ = this.currentUserSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  constructor(private http: HttpClient, private router: Router) {
    // para que desde el principio se sepa si ya está logueado
    if (localStorage.getItem('currentUser')) {
      this.currentUserSubject.next(
        JSON.parse(localStorage.getItem('currentUser'))
      );
      this.logueadoSource.next(true);
    }
  }

  login(username: string, password: string) {
    return this.http
      .post<any>(this.baseUrl + '/login_check', {
        _username: username,
        _password: password
      })
      .pipe(
        map(user => {
          this.loguearUsuario(user);

          return user;
        })
      );
  }

  logout(redirect=true) {
    const that = this;
    return this.http.get<any>(this.baseUrl + '/logout').pipe(
      map(data => {
        console.log(data);
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        that.currentUserSubject.next({});
        that.logueadoSource.next(false);
        if(redirect){
          that.router.navigate(['/login']);
        }
        return data;
      })
    );
  }

  verifyToken(id_token) {
    return this.http.post(this.baseUrl + '/verify-token',  {idtoken: id_token});
  }

  loguearUsuario(user) {
    // login successful if there's a jwt token in the response
    if (user && user.username) {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem('currentUser', JSON.stringify(user));
      this.currentUserSubject.next(user);
      this.logueadoSource.next(true);
    }
  }
}
